import {
  MessageCircle,
  Mail,
  Facebook,
  Twitter,
  Send,
  Ghost
} from 'lucide-react';
import type { ShareLink } from './types';

export function getShareLinks(pollUrl: string, pollName: string, shareText?: string): ShareLink[] {
  const subject = shareText ? `Results for "${pollName}" poll` : `Vote in my "${pollName}" poll`;
  const body = shareText ? `${shareText}: ${pollUrl}` : `Please vote in my "${pollName}" poll: ${pollUrl}`;

  return [
    {
      name: 'Text Message',
      icon: MessageCircle,
      url: `sms:?body=${encodeURIComponent(body)}`,
    },
    {
      name: 'Email',
      icon: Mail,
      url: `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`,
    },
    {
      name: 'Facebook',
      icon: Facebook,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pollUrl)}&quote=${encodeURIComponent(body)}`,
    },
    {
      name: 'X',
      icon: Twitter,
      url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(body)}`,
    },
    {
      name: 'WhatsApp',
      icon: Send,
      url: `https://wa.me/?text=${encodeURIComponent(body)}`,
    },
    {
      name: 'Snapchat',
      icon: Ghost,
      url: `snapchat://share?text=${encodeURIComponent(body)}`,
    },
  ];
}